import React from 'react';
import type { Mode } from './types';
import type { ThemeConfig } from './types';
import type { Theme, ThemeOptions } from '@mui/material/styles';
import type { Settings } from './context/settingsContext';

const themeConfig: {
  config: ThemeConfig;
  options: (theme: Theme, settings: Settings) => ThemeOptions;
} = {
  config: {
    // ** Layout Configs
    layout: 'horizontal',
    mode: 'dark' as Mode,
    direction: 'ltr',
    skin: 'default',
    contentWidth: 'full',
    footer: 'hidden',

    // ** Routing Configs
    routingLoader: true,

    // ** Palette Configs
    lightColor: '#FFF',
    darkColor: '#000',
    primaryColor: '#FF0000',
    secondaryColor: '#00FF00',
    backColor: '#002F9A',
    backTheme: 'midnight-static',

    // ** Navigation (Menu) Configs
    navHidden: false,
    navBelow: false,
    menuTextTruncate: true,
    menuTextHidden: false,
    navSubItemIcon: 'circle-outline',
    verticalNavToggleType: 'accordion' /* For Vertical navigation menu only */,
    navCollapsed: false /* For Vertical navigation menu only */,
    navigationSize: 260 /* For Vertical navigation menu only (px) */,
    collapsedNavigationSize: 68 /* For Vertical navigation menu only (px) */,
    contentPadding: 6 /* Number for theme.spacing() */,
    afterVerticalNavMenuContentPosition: 'fixed' /* fixed | static */,
    beforeVerticalNavMenuContentPosition: 'fixed' /* fixed | static */,
    horizontalMenuAnimation: true /* true | false */,

    // ** AppBar Configs
    appBar:
      'fixed' /* fixed | static | hidden /*! Note: hidden value will only work for Vertical Layout */,
    backgroundFilter: 'none',

    // ** Other Configs
    responsiveFontSizes: true /* true | false */,
    disableRipple: false /* true | false */,
    disableCustomizer: true /* true | false */,
    fontAwesomePrefix: 'fal',
    toastPosition:
      'top-right' /* top-left | top-center | top-right | bottom-left | bottom-center | bottom-right */,
    branding: () => React.createElement('div'),
    brandMark: () => React.createElement('div'),
    pinnedConnectors: [],
  },
  options: () => {
    return {};
  },
};

export default themeConfig;
